import '../Styles/InfoFooter.css';

import React from "react";
import { BsXCircleFill } from 'react-icons/bs';

import lang from "../Localization";

class InfoFooter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shown: true
        }
    }

    hide = () => {
        this.setState({shown: false});
    }

    render() {
        if(!this.state.shown) return null;

        return (
            <div id="info-footer">
                <span onClick={this.hide} id="hide-info-footer-button"><BsXCircleFill/></span>
                {lang.infoFooter} <a href={lang.legalDepositContactFormURL} onClick={this.props.appFunctions.openFeedbackForm}>{lang.infoFooterContactLink}</a>
            </div>
        );
    }
  }

  export { InfoFooter }